import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/index.css'
import './assets/dmgAssets/css/style.css'
import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import unregister from './registerServiceWorker';
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType, EventType } from "@azure/msal-browser";
import { pca, loginRequest, getCurrentUsername, isDMGUser } from './authProvider';
import FileEx from './pages/FileEx';
import CreateArea from './pages/CreateArea';
import CreateUser from './pages/CreateUser';
import FileExLogo from './components/FileExLogo';
import Spinner from './components/Spinner';
import { checkAccess, getAppSettingsInfo } from './fetchData';
import toast, { Toaster } from 'react-hot-toast';
import AdHoc from './pages/AdHoc';
import ApproveArea from './pages/ApproveArea';
import AdminPage from './pages/AdminPage';

const rootElement = document.getElementById('root');

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            username: '',
            userAllowed: false,
            accessChecked: false,
            canCreateAreas: false,
            appSettings: { isUsaVersion: false, adHocAreasEnabled: true, userSearchOnlyWithValidEmailAddressAllowed: false },
        }

        this.errorComponent = this.errorComponent.bind(this);
        this.loadingComponent = this.loadingComponent.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
        getAppSettingsInfo().then((res) => {
            this.setState({
                appSettings: res
            });
        }).catch(() => {
            toast.error("Error loading app settings.");
        })
        pca.addEventCallback(message => {
            switch (message.eventType) {
                case EventType.HANDLE_REDIRECT_END:
                    // Skip authentication for adhoc route
                    if (window.location.pathname === '/adhoc') {
                        return;
                    }
                    if (isDMGUser()) {
                        checkAccess().then((res) => {
                            this.setState({
                                username: getCurrentUsername(),
                                userAllowed: !res.isDenied,
                                accessChecked: true,
                                canCreateAreas: res.canCreateAreas
                            });
                        }).catch(() => {
                            toast.error("Error authorizing user.");
                        })
                    }
                    else {
                        // B2C user: call checkAccess to check blacklist status
                        checkAccess().then((res) => {
                            this.setState({
                                username: getCurrentUsername(),
                                userAllowed: !res.isDenied,
                                accessChecked: true
                            });
                        }).catch(() => {
                            this.setState({
                                username: getCurrentUsername(),
                                userAllowed: true,
                                accessChecked: true
                            });
                        })
                    }
                    break;
                default:
                    break;
            }
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    updateWidth = () => {
        this.setState({
            width: window.innerWidth
        })
    }

    errorComponent = ({ error }) => {
        return (
            <div className="content" style={{ textAlign: "center" }}>
                <div style={{ marginBottom: 10, width: this.state.width > 800 ? "75%" : "100%", display: "inline-block" }}>
                    <FileExLogo />
                    <div style={{ flex: '0 0 auto' }}>
                        An error occurred: {error ? error.errorCode : "unknown error"}
                    </div>
                </div>
            </div>
        )
    }

    loadingComponent = () => {
        return (
            <div className="content" style={{ textAlign: "center" }}>
                <div style={{ marginBottom: 10, width: this.state.width > 800 ? "75%" : "100%", display: "inline-block" }}>
                    <FileExLogo />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flex: '1' }}>
                            <Spinner />
                        </div>
                        <div style={{ flex: '0 0 auto' }}>
                            Authentication in progress...
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    downloadManual = (lang) => {
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
        var guideTab = window.open(baseUrl + "api/download/manual/" + lang + "/FileEx Manual", '_blank');
        guideTab.focus();
    }

    render() {
        const authRequest = {
            ...loginRequest
        };
        return (
            <Router>
                <MsalProvider instance={pca}>
                    <div className="content" style={{ textAlign: "center" }}>
                        <Toaster />
                        <div style={{ marginBottom: 10, width: this.state.width > 800 ? "75%" : "100%", display: "inline-block" }}>

                            <Switch>
                                <Route exact path='/'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <FileEx {...this.props} appWidth={this.state.width} accessChecked={this.state.accessChecked} userAllowed={this.state.userAllowed}
                                            appSettings={this.state.appSettings} canCreateAreas={this.state.canCreateAreas} />
                                    </MsalAuthenticationTemplate>
                                </Route>

                                <Route exact path='/createArea'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <CreateArea />
                                    </MsalAuthenticationTemplate>
                                </Route>

                                <Route exact path='/createUser'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <CreateUser />
                                    </MsalAuthenticationTemplate>
                                </Route>

                                <Route exact path='/approveArea'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <ApproveArea {...this.props} appWidth={this.state.width} accessChecked={this.state.accessChecked} userAllowed={this.state.userAllowed}
                                            appSettings={this.state.appSettings} />
                                    </MsalAuthenticationTemplate>
                                </Route>
                                <Route exact path='/admin'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <AdminPage {...this.props} appWidth={this.state.width} appSettings={this.state.appSettings} />
                                    </MsalAuthenticationTemplate>
                                </Route>
                                <Route exact path='/adhoc'>
                                    <AdHoc {...this.props} appWidth={this.state.width} appSettings={this.state.appSettings} />
                                </Route>
                                <Route render={() => <Redirect to="/" />} />
                            </Switch>
                        </div>
                    </div>
                </MsalProvider>
            </Router>
        )
    }
}

ReactDOM.render(
    <App />,
    rootElement);

unregister();

